const development = 'development';

export const isDevelopment = process.env.TARGET_ENV === development;
